import { render, staticRenderFns } from "./SimpleKeyBoard.vue?vue&type=template&id=2b0aca82&"
import script from "./SimpleKeyBoard.vue?vue&type=script&lang=js&"
export * from "./SimpleKeyBoard.vue?vue&type=script&lang=js&"
import style0 from "./SimpleKeyBoard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports